import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import './styles/quasar.styl'
import iconSet from 'quasar-framework/icons/fontawesome'
import 'quasar-extras/animate'
import 'quasar-extras/fontawesome'
import Quasar from 'quasar'
import VueKatex from 'vue-katex'

const global_cutting_data = {
  d: 1,
  r: 0.5,
  d_eff: 0,
  z: 2,
  n: 0,
  ae: 0,
  ap: 0,
  vf: 0,
  vc: 0,
  fz: 0,
  fn: 0,
  ft: 0,
  install: function () {
    Object.defineProperty(Vue.prototype, '$cuttingData', {
      get () { return global_cutting_data }
    })
  }
};

Vue.use(global_cutting_data);
Vue.use(VueKatex);
Vue.use(Quasar, {
  config: {}, iconSet: iconSet
 });

Vue.config.productionTip = false;


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
